<template >
<div class="header-logo"  @click="$router.push({ path: '/'})" >
  <img  :src="data.Page_index_header_logo"/>
  <!-- <span>海外仓综合供应链平台（北美 · 欧洲 · 亚太）</span> -->
</div>
  
</template>

<script>
import i18n from '@/mixins/i18n'
export default {
  mixins: [i18n]
}
</script>
<style lang="scss" scoped>
.header-logo {
  height: 64px;
  line-height: 64px;
  margin-top: 10px;
  display: flex;
}
img {
  width: 144px;
  height: 64px;
  object-fit: contain;
  margin-right: 40px;
}
span {
  font-size: 12px;
  color: #000;
}
</style>
